<sbnb-thermostat-preset-adjustment
  [config]="{
    title: 'Unoccupied',
    question: 'between stays',
    icon: 'unoccupied',
    continueRoute: 'long-term-unoccupied',
    presetType: 'unoccupied'
  }">
  <p>
    The
    <strong>Unoccupied preset</strong>
    activates
    <strong>at check-out</strong>
    to save energy while keeping your property ready for the next guest.
  </p>

  <p>
    If cleaners or maintenance adjust a thermostat at the property between stays, their charges will
    <strong>hold for 2 hours</strong>
    before reverting to the
    <strong>Unoccupied preset.</strong>
  </p>
</sbnb-thermostat-preset-adjustment>
